import type { HelpFile } from '../../types/help'
import { SectionCardTestIds } from '../../../testids/SectionCardTestIds'

export const sectionCardHelp: HelpFile = {
  docPage: '/docs/admin/form-layout-designer',
  texts: {
    [SectionCardTestIds.sectionLabelBtn]:
      'Beschriftung bearbeiten, die im gerenderten Formular über diesem Abschnitt angezeigt wird.',
    [SectionCardTestIds.sectionColumnsSelect]:
      'Anzahl der Spalten wählen, mit denen dieser Abschnitt seine Felder anordnet.',
    [SectionCardTestIds.sectionDeleteBtn]:
      'Diesen Abschnitt und alle darin enthaltenen Felder löschen. Diese Aktion kann nicht rückgängig gemacht werden.',
  },
}
